<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/158EqZT/tc-custom/9781611521450.jpg?1723406026275" alt="This image is the cover for the book Off Balance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Off Balance
      </h1>
      <p class="bookDescription body article font2">
        <p>When you're a middle-aged farmer's wife looking at the handsome younger man your son has brought home for Christmas, it's harmless, isn't it? No flirting, no innuendo, just keeping an eye on him. It doesn't mean anything, right?<br/><br/>Sara wouldn't dream of cheating on her husband, but when David brings home a friend from college, she's faced with a hundred questions she doesn't have the answers to. And it all leaves her feeling<i>Off Balance.</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Belea T. Keeney
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01a624cc